import React, { useEffect } from 'react';
import PageCarousel from '../components/PageCarousel';

function Speakers() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const speakers = [
    {
      id: 'an-rajagopalan',
      name: 'Prof. A.N. Rajagopalan',
      affiliation: 'Indian Institute of Technology (IIT) Madras',
      image: '/assets/img/speaker/rajagopalan.jpg',
      url: 'https://www.ee.iitm.ac.in/raju/',
      type: "Keynote Speakers",
      talkTitle: "Vision Methodologies for Scene Understanding in Underwater and Sea-surface Imagery",
      abstract: "The talk will cover ongoing research involving computer vision techniques for underwater depth and image reconstruction, and sea-surface geo-referencing from air drills over the ocean using drones with cameras and motion sensors."
    },
    {
      id: 'venkatesh-babu',
      name: 'Prof. R. Venkatesh Babu',
      affiliation: 'Indian Institute of Science (IISc), Bangalore',
      image: '/assets/img/speaker/venkatesh.jpg',
      url: 'https://cds.iisc.ac.in/faculty/venky/',
      type: "Keynote Speakers",
      talkTitle: "From Controllable Generation to Trustworthy AI: Advances in Visual Foundation Models",
      abstract: "Recent advances in foundation models have dramatically expanded the capabilities of visual AI systems, enabling high-quality image, video, and 3D content generation from natural language instructions. However, deploying these models in real-world applications requires progress along two complementary dimensions: controllability and trustworthiness. The first part of the talk will focus on controllable generative models, covering advances in instruction-guided image editing, 3D-aware content generation, controllable scene manipulation, and understanding the physical limitations of modern image and video generation systems. These developments aim to move beyond purely photorealistic generation toward models that can be reliably steered, edited, and integrated into downstream creative and scientific workflows. The second part will focus on trustworthy visual AI, where our recent efforts in understanding and improving the data foundations of modern learning systems, including dataset distillation, fairness-aware data generation, diversity evaluation of generative models, and principled benchmarking methodologies. These works highlight the challenges of ensuring that increasingly capable models remain representative, robust, and reliable. Together, these directions point toward a broader vision for next-generation visual foundation models: systems that are not only powerful generators of visual content, but are also controllable, interpretable, fair, and trustworthy."
    },
    {
      id: 'kumar-ajay',
      name: 'Prof. Ajay Kumar',
      affiliation: 'The Hong Kong Polytechnic University, Hong Kong',
      image: '/assets/img/speaker/kumar-ajay.jpg',
      url: 'https://www.polyu.edu.hk/dsai/people/academic-staff/kumarajay/?sc_lang=en',
      type: "Keynote Speakers",
      talkTitle: "When Identity Meets AI: Towards Accurate, Explainable, and Contactless Palmprint Identification",
      abstract: "Contactless palmprint identification is poised to become a defining biometric in the next generation of trusted digital identity, offering a rare combination of convenience, hygiene, security, and user acceptability for high-impact applications ranging from fintech and e-payment to e-security, healthcare, and intelligent access control. Its transition from research labs to operational deployment is already underway, with palm-based authentication appearing in cashless payment systems, smart transit infrastructure, and mobile identity platforms, signaling strong momentum toward large-scale adoption. Yet the real breakthrough lies ahead: to fully realize the transformative potential of this biometric, the research community must address critical challenges, including cross-device generalization, robust spoof resistance, privacy-preserving template protection, the ability to synthesize large-scale datasets, and the need to develop an explainable contactless palmprint-matching algorithm. In this keynote, I will discuss recent advances in fully contactless, spoof-resistant palmprint identification and outline research challenges for building highly accurate, explainable, scalable, and dependable biometric systems for real-world deployment."
    },
    {
      id: 'mayank-vatsa',
      name: 'Prof Mayank Vatsa',
      affiliation: 'Indian Institute of Technology Jodhpur, Rajasthan, India',
      image: '/assets/img/speaker/mayank-vatsa.jpg',
      url: 'https://iitj.irins.org/profile/109034',
      type: "Keynote Speakers",
      talkTitle: "From Capability to Control: Engineering Trustworthy Generative AI",
      abstract: "Generative AI has crossed a threshold of capability, but capability without control is a fragile foundation for systems that society is beginning to depend on. The harder question is no longer only what these models can produce, but what we can reliably make them do: follow instructions, respect negation, count correctly, compose visual concepts faithfully, align with human intent, and serve social good rather than undermine it. This talk frames reliable control as a central challenge in trustworthy generative AI. It first examines subtle but important failures in current vision and language systems. These models often appear powerful, but still struggle with basic forms of linguistic, numerical, and compositional control. The second part focuses on two areas where control becomes a matter of public trust. The first is deepfakes and synthetic media, where generative power can threaten identity and the integrity of shared information. The second is machine unlearning, the still-open challenge of making models remove knowledge, data, or concepts in a reliable and verifiable way. Together, these threads argue that reliability, alignment, accountability, and forgetting must be treated as first-class engineering properties of generative AI, not as afterthoughts."
    }, 
    {
      id: 'sushmita-mitra',
      name: 'Prof. Sushmita Mitra',
      affiliation: 'Indian Statistical Institute, Kolkata',
      image: '/assets/img/speaker/sushmita-mitra.jpg',
      url: 'https://oldweb.isical.ac.in/~sushmita/',
      type: "Keynote Speakers",
      talkTitle: "Harnessing  AI for Healthcare",
      abstract: ": With the inherent boom in availability of large volumes of multimodal healthcare data over the internet, their automated processing is becoming all the more relevant in today's perspective. Manual Delineation and processing is expensive, biased, and slow. Here lies the utility of artificial intelligence, encompassing machine learning and deep learning. The role of AI is in providing assistive intelligence to healthcare professionals, in their endeavour to arrive at cost-effective, fast, and viable solutions for complex decision-making. This talk outlines the role of AI in several aspects of healthcare, encompassing classification, segmentation, and survival prediction. We discuss applications with multimodal imagery spanning over X-ray, CT, MR, fundus images, to handle some diseases. Finally, a deformable deep net is introduced for efficient segmentation."
    },   
    {
      id: 'francois-bremond',
      name: 'Dr. Francois Bremond',
      affiliation: 'Research Director, INRIA Sophia Antipolis Director',
      image: '/assets/img/speaker/francois-bremond.jpg',
      url: 'https://www-sop.inria.fr/members/Francois.Bremond/',
      type: "Keynote Speakers",
      talkTitle: "Video Human Action Understanding",
      abstract: "In this talk, we will explore how action recognition can be applied to human monitoring by analyzing video streams. Existing work has either focused on simple activities in real-life scenarios or on recognizing more complex activities (in terms of visual variability) in hand-clipped videos with well-defined temporal boundaries. However, there remains a gap in methods capable of retrieving multiple instances of complex human activity in a continuous (untrimmed) video flow in real-world settings. We will first present a few techniques for detecting and tracking individuals in different environments. We will discuss various modalities, such as skeleton, optical flow, and emotion recognition, that can aid in the activity recognition process. We will then review state-of-the-art models for activity recognition and detection, including those using self-attention, transformers, and different pre-training methods. We will also cover specific cases of activity detection, such as video anomaly detection using weakly-supervised methods. Then, we will discuss several new techniques for recognizing Activities of Daily Living (ADLs) using video cameras. The proposed activity monitoring approaches will be illustrated through several home-care application datasets, including Toyota SmartHome, NTU-RGB+D, Charades, and Northwestern UCLA. This comprehensive talk will provide a thorough understanding of the current state and future directions of action detection for human monitoring in various real-world contexts."
    },      
    {
      id: 'brojeshwar-bhowmick',
      name: 'Dr. Brojeshwar Bhowmick',
      affiliation: 'Principal Scientist and head of Visual Computing and Embodied AI, TCS Research',
      image: '/assets/img/speaker/brojeshwar.jpeg',
      url: 'https://sites.google.com/view/brojeshwar/home?authuser=0',
      type: "Invited Speakers",
      talkTitle: "Future of Spatial Computing",
      abstract: "The integration of augmented reality (AR), virtual reality (VR), and mixed reality (MR) technologies is transforming human-computer interaction. Spatial computing enables seamless blending of physical and virtual worlds, promising to revolutionize various aspects of life. This technology leverages advancements in hardware innovations, AI capabilities, and sensor technologies to provide users with immersive and interactive experiences. With the potential to enhance human memory, anticipate future events, and aid industrial tasks, spatial computing is poised to transform industries and daily activities alike. This talk explores the current state and future directions of spatial computing, highlighting its transformative power in creating a more interactive and intelligent world."
    },
    {
      id: 'v-manavala',
      name: 'Sri V Manavala Ramanujam',
      affiliation: 'Scientist, ISRO',
      image: '',
      url: '#',
      type: "Invited Speakers",
      talkTitle: "NASA-ISRO SAR (NISAR) Data and Image Processing",
      abstract: ""
    }    
  ];

  // Get unique speaker types dynamically
  const types = [...new Set(speakers.map(s => s.type))];

  return (
    <div className="page-container">
      <PageCarousel />

      <section className="section-padding bg-light py-5">
        <div className="container">
          <div className="row">
            <div className="col-12">
              
              {/* Page Title Section */}
              <div className="text-center mb-5">
                <h1 className="fw-bold" style={{ color: '#002147' }}>Invited Talks</h1>
              </div>
              
              {/* Loop over each type */}
              {types.map((type) => {
                const filteredSpeakers = speakers.filter(s => s.type === type);

                return (
                  <div key={type} className="mb-5">

                    

                    {/* Speakers Grid - 1 Row per Speaker */}
                    <div className="row">
                      {filteredSpeakers.map((speaker) => (
                        <div key={speaker.id} className="col-12 mb-4">
                          <div className="speaker-card d-flex flex-column flex-md-row align-items-start align-items-md-center" style={{
                            backgroundColor: '#fff',
                            borderRadius: '12px',
                            boxShadow: '0 4px 20px rgba(0,0,0,0.06)',
                            padding: '30px',
                            height: '100%',
                            borderLeft: '6px solid #70b60a'
                          }}>

                            {/* Speaker Image */}
                            <div className="flex-shrink-0 me-md-4 mb-3 mb-md-0 mx-auto mx-md-0">
                              <img 
                                src={speaker.image} 
                                alt={speaker.name} 
                                style={{
                                  width: '130px',
                                  height: '130px',
                                  borderRadius: '50%',
                                  objectFit: 'cover',
                                  border: '4px solid #f8f9fa'
                                }}
                                onError={(e) => { e.target.src = 'https://via.placeholder.com/150?text=Speaker'; }}
                              />
                            </div>

                            {/* Speaker & Talk Details */}
                            <div className="speaker-info w-100 text-center text-md-start">
                              <h4 style={{ margin: '0 0 5px 0', fontSize: '22px' }}>
                                <a 
                                  href={speaker.url} 
                                  target="_blank" 
                                  rel="noopener noreferrer"
                                  style={{ 
                                    color: '#002147', 
                                    textDecoration: 'none',
                                    fontWeight: '700'
                                  }}
                                >
                                  {speaker.name}
                                </a>
                              </h4>

                              <p className="text-secondary fw-semibold mb-3" style={{ fontSize: '15px' }}>
                                {speaker.affiliation}
                              </p>

                              <hr className="my-2" style={{ opacity: '0.15' }} />

                              {/* Talk Title Section */}
                              <div className="mt-2">
                               
                                <p className="text-dark font-italic mb-2" style={{ fontSize: '16px', fontWeight: '500' }}>
                                  {speaker.talkTitle}
                                </p>
                              </div>

                              {/* Abstract Section */}
                              <div className="mt-2">
                                
                                <p className="text-muted small mb-0" style={{ lineHeight: '1.5', whiteSpace: 'pre-line' }}>
                                  {speaker.abstract}
                                </p>
                              </div>

                            </div>

                          </div>
                        </div>
                      ))}
                    </div>

                  </div>
                );
              })}

            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Speakers;